(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncMuteUi(ui, video) {
      const muted = video.muted;
      const btn = ui.querySelector('[data-hero-video-mute]');
      const on = ui.querySelector('.hero__video-control-icon--volume-on');
      const off = ui.querySelector('.hero__video-control-icon--volume-off');
      if (!btn || !on || !off) return;
      btn.setAttribute('aria-pressed', muted ? 'true' : 'false');
      btn.setAttribute('aria-label', muted ? ui.dataset.labelUnmute : ui.dataset.labelMute);
      on.hidden = muted;
      off.hidden = !muted;
    }

    function syncPlayUi(ui, video) {
      const paused = video.paused;
      const btn = ui.querySelector('[data-hero-video-playpause]');
      const iconPause = ui.querySelector('.hero__video-control-icon--pause');
      const iconPlay = ui.querySelector('.hero__video-control-icon--play');
      if (!btn || !iconPause || !iconPlay) return;
      btn.setAttribute('aria-pressed', paused ? 'false' : 'true');
      btn.setAttribute('aria-label', paused ? ui.dataset.labelPlay : ui.dataset.labelPause);
      iconPause.hidden = paused;
      iconPlay.hidden = !paused;
    }

    function bindUi(ui, root) {
      const key = ui.getAttribute('data-hero-video-ui');
      if (!key) return;
      const wrap = root.querySelector('[data-hero-video-root="' + key + '"]');
      if (!wrap) return;
      const video = wrap.querySelector('video');
      if (!video) return;

      const setFallback = function (active) {
        wrap.classList.toggle('hero__video-inner--fallback', Boolean(active));
      };

      const muteBtn = ui.querySelector('[data-hero-video-mute]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          root.querySelectorAll('[data-hero-video-ui="' + key + '"]').forEach(function (other) {
            syncMuteUi(other, video);
          });
        });
      }

      const ppBtn = ui.querySelector('[data-hero-video-playpause]');
      if (ppBtn) {
        ppBtn.addEventListener('click', function () {
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });
      }

      if (!video._heroVideoUiBound) {
        video._heroVideoUiBound = true;
        const syncKey = key;
        const fallbackCheck = function () {
          const hasRenderableFrame = video.readyState >= 2;
          const playing = !video.paused && !video.ended;
          setFallback(!(hasRenderableFrame && playing));
        };

        video.addEventListener('volumechange', function () {
          root.querySelectorAll('[data-hero-video-ui="' + syncKey + '"]').forEach(function (other) {
            syncMuteUi(other, video);
          });
        });
        video.addEventListener('play', function () {
          setFallback(false);
          root.querySelectorAll('[data-hero-video-ui="' + syncKey + '"]').forEach(function (other) {
            syncPlayUi(other, video);
          });
        });
        video.addEventListener('playing', function () {
          setFallback(false);
        });
        video.addEventListener('loadeddata', function () {
          fallbackCheck();
        });
        video.addEventListener('pause', function () {
          root.querySelectorAll('[data-hero-video-ui="' + syncKey + '"]').forEach(function (other) {
            syncPlayUi(other, video);
          });
        });
        ['error', 'stalled', 'suspend', 'abort', 'emptied', 'waiting'].forEach(function (evt) {
          video.addEventListener(evt, function () {
            setFallback(true);
          });
        });

        // If autoplay is blocked or too slow, show fallback controls.
        setTimeout(fallbackCheck, 2000);
      }

      syncMuteUi(ui, video);
      syncPlayUi(ui, video);
    }

    function initHeroVideoBarBottomOffset(hero) {
      if (!hero.classList.contains('hero--has-video')) return;

      if (hero._heroBarOffsetCleanup) {
        hero._heroBarOffsetCleanup();
        hero._heroBarOffsetCleanup = null;
      }

      const content = hero.querySelector('.hero__content-wrapper');
      if (!content) return;

      let roGroup = null;
      let mo = null;
      const mql = window.matchMedia('(max-width: 749px)');

      const apply = function () {
        if (!mql.matches) {
          hero.style.removeProperty('--hero-first-group-block-height');
          return;
        }
        const firstGroup = content.querySelector('.group-block');
        const h = firstGroup ? firstGroup.offsetHeight : 0;
        hero.style.setProperty('--hero-first-group-block-height', h + 'px');
      };

      const bindGroupResizeObserver = function () {
        if (roGroup) {
          roGroup.disconnect();
          roGroup = null;
        }
        const fg = content.querySelector('.group-block');
        if (!fg) return;
        roGroup = new ResizeObserver(apply);
        roGroup.observe(fg);
      };

      apply();
      bindGroupResizeObserver();

      mo = new MutationObserver(function () {
        bindGroupResizeObserver();
        apply();
      });
      mo.observe(content, { childList: true, subtree: false });

      const onViewportChange = function () {
        apply();
      };
      window.addEventListener('resize', onViewportChange, { passive: true });
      mql.addEventListener('change', onViewportChange);

      hero._heroBarOffsetCleanup = function () {
        if (roGroup) roGroup.disconnect();
        if (mo) mo.disconnect();
        window.removeEventListener('resize', onViewportChange);
        mql.removeEventListener('change', onViewportChange);
        hero.style.removeProperty('--hero-first-group-block-height');
      };
    }

    function initHeroVideo(root) {
      if (!root || !root.classList || !root.classList.contains('hero')) return;
      root.querySelectorAll('[data-hero-video-ui]').forEach(function (ui) {
        bindUi(ui, root);
      });
      initHeroVideoBarBottomOffset(root);
    }

    document.querySelectorAll('.hero').forEach(initHeroVideo);

    document.addEventListener('shopify:section:load', function (event) {
      const hero = event.target && event.target.querySelector && event.target.querySelector('.hero');
      if (hero) initHeroVideo(hero);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
